import { useTranslation } from 'react-i18next';

import { Box } from '@/shared/ui';
import { Dialog, TDialogBase } from '@/shared/ui/Dialog';
import { Button } from '@/shared/ui/lib/Button';

export const ChannelPendingDialog = ({
  onClose,
  ...otherProps
}: TDialogBase) => {
  const { t } = useTranslation();

  return (
    <Dialog
      onClose={onClose}
      title={t('channels:channelPendingDialog.title')}
      leftButtonSlot={
        <Button variant="outlined" onClick={onClose}>
          {t('common:buttons.close')}
        </Button>
      }
      sx={{
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '650px',
      }}
      {...otherProps}
    >
      <Box>{t('channels:channelPendingDialog.description')}</Box>
    </Dialog>
  );
};
